import React, { useEffect, useRef, useState } from 'react';
import { ExternalComponentModel } from './models/externalComponent.model';
import LazySection from '../lazySection';
import { TExternalComponentProps } from './types/externalComponent.types';
import { windowService } from '../../../utils/window.utils.js';
import UnreleasedComponent from '../unreleasedComponent';
import { googleFormSubmitEvent } from '../../../utils/analytics';

const SharedExternalComponent = (props: TExternalComponentProps) => {
  const model = new ExternalComponentModel(props);
  const { url, height, visibilityDelay } = model;
  const [iFrameHeight, setiFrameHeight] = useState(height.toString());
  const [isVisible, setIsVisible] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    function messageListener(event: MessageEvent) {
      if (
        event.origin === new URL(url).origin &&
        event.data &&
        typeof event.data === 'string' &&
        event.data.includes('iframeHeightChange')
      ) {
        const iframeHeight = event.data.replace('iframeHeightChange#=###=###=#', '');
        iframeHeight && setiFrameHeight(iframeHeight);
      }
    }

    windowService().addEventListener('message', messageListener);

    return () => {
      windowService().removeEventListener('message', messageListener);
      clearTimeout(timer?.current as ReturnType<typeof setTimeout>);
    };
  }, [url]);

  useEffect(() => {
    function messageListener(event: MessageEvent): void {
      const messageName = 'iframe FormResponse#=###=###=#';
      const delimiter = ',';

      if (event.origin === new URL(url).origin && event.data && typeof event.data === 'string' && event.data.includes(messageName)) {
        const formSubmitData = event.data.replace(messageName, '');
        const dataParts = formSubmitData.split(delimiter);
        const statusCode = dataParts[0];

        if (statusCode === '200') {
          const hasAttachment = dataParts[1] === '1';
          const formName = dataParts[2];

          googleFormSubmitEvent(formName, hasAttachment);
        }
      }
    }

    windowService().addEventListener('message', messageListener);

    return (): void => {
      windowService().removeEventListener('message', messageListener);
    };
  }, []);

  const onLoadHandler = (): void => {
    timer.current = setTimeout(() => setIsVisible(true), visibilityDelay);
  };

  const iframeStyle = {
    height: `${iFrameHeight || height}px`,
    opacity: isVisible ? 1 : 0,
  };

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <LazySection>
      <section className="external-Component">
        {/* eslint-disable-next-line */}
        <iframe src={url} style={iframeStyle} onLoad={onLoadHandler} allow="geolocation"></iframe>
      </section>
    </LazySection>
  );
};

export default SharedExternalComponent;
